import Vue from 'vue'
import axios from 'axios'
import { auth } from '@/helpers/firebaseHelpers'
import { signOut } from 'firebase/auth'

const vueObj = new Vue()

const state = {
  admin: null,
  admins: [],
  error: '',
  loading: false,
  permissions: [],
  departmentTagIds: [],
  allowPermission: false
}

const actions = {
  fetchAdmins: async ({ commit }) => {
    const url = 'admins'
    const res = await axios.get(url)
    if (res.status === 200) {
      const admins = res.data
      commit('SET_ADMINS', admins)
    } else {
      vueObj.$swal({ text: res.data.error })
    }
  },
  fetchAdmin: async ({ commit }, id) => {
    const url = `admins/${id}`
    const res = await axios.get(url)
    if (res.status === 200) {
      const admin = res.data.admin
      commit('SET_ADMIN', admin)
    } else {
      vueObj.$swal({ text: res.data.error })
    }
  },
  updateStatus: async ({ commit }, submitData) => {
    const url = `admins/active`
    const res = await axios.post(url, submitData)
    if (res.status === 200) {
      const admin = res.data.admin
      commit('SET_ADMIN', admin)
    } else {
      vueObj.$swal({ text: res.data.error })
    }
  },
  LOGIN_WITH_FIREBASE: ({ commit, dispatch }, params) => {
    return new Promise(async (resolve, reject) => {
      let { data } = await axios.post('/login', params)
      if (!data.error) {
        const accessToken = data.access_token
        if (localStorage) {
          localStorage.setItem('access_token', accessToken)
          commit('SET_ADMIN', data.admin)
          resolve(data.admin)
        }
      } else {
        commit('SET_ERROR', data.message)
        reject(data.message)
      }
    })
  },
  LOGOUT: async ({ commit, dispatch, state }) => {
    return new Promise(async (resolve, reject) => {
      commit('general/SET_REDIRECT_URL', '', { root: true })
      const loggedInUser = auth.currentUser
      if (loggedInUser) {
        signOut(auth).then(() => {
          console.log('firebase logout success')
        }).catch((error) => {
          reject(error.message)
        })
      }
      if (state.admin && state.admin.id) {
        let { data } = await axios.post('/logout')
        console.log('Logout Success: ', state.admin.id, data)
      }
      commit('SET_ADMIN', null)
      commit('SET_PERMISSIONS', [])
      commit('SET_ALLOW_PERMISSION', false)
      localStorage.clear()
      resolve('success')
    })
  },
  fetchPermissions: async ({ commit }, paramsPermission) => {
    const url = `admins/permissions/${paramsPermission.admin_id}`
    try {
      const res = await axios.get(url)
      if (res.status === 200 && res.data) {
        const raw = res.data.permission != null ? res.data.permission : res.data.permissions
        let permissionList = []
        if (Array.isArray(raw)) {
          permissionList = raw
        } else if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
          permissionList = Object.keys(raw).filter(function (key) { return raw[key] })
        }
        const requested = paramsPermission.permissions || []
        const allowed = requested.filter(function (item) { return permissionList.indexOf(item) >= 0 })
        commit('SET_PERMISSIONS', allowed)
        if (res.data.departmentTagIds) {
          commit('SET_DEPARTMENT_TAG_IDS', res.data.departmentTagIds)
        }
      } else {
        commit('SET_PERMISSIONS', [])
        commit('SET_ALLOW_PERMISSION', false)
        if (res.data && res.data.error) vueObj.$swal({ text: res.data.error })
      }
    } catch (e) {
      commit('SET_PERMISSIONS', [])
      commit('SET_ALLOW_PERMISSION', false)
      if (e.response && e.response.data && e.response.data.error) vueObj.$swal({ text: e.response.data.error })
    }
  },
  checkPermissions: ({ state, commit }, keyword) => {
    if (state.permissions && Array.isArray(state.permissions) && state.permissions.indexOf(keyword) >= 0) {
      commit('SET_ALLOW_PERMISSION', true)
    } else {
      commit('SET_ALLOW_PERMISSION', false)
    }
  }
}

const mutations = {
  SET_ADMINS: (state, admins) => {
    state.admins = admins
  },
  SET_ADMIN: (state, payload) => {
    state.admin = payload
  },
  SET_ERROR: (state, payload) => {
    state.error = payload
  },
  ADD_PROPERTY_ADMIN (state, data) {
    state.admin[data.key] = JSON.parse(JSON.stringify(data.value))
  },
  SET_PERMISSIONS: (state, payload) => {
    state.permissions = Array.isArray(payload) ? payload : []
  },
  SET_ALLOW_PERMISSION: (state, payload) => {
    state.allowPermission = Boolean(payload)
  },
  SET_DEPARTMENT_TAG_IDS: (state, payload) => {
    state.departmentTagIds = payload
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
